var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13268 7.56676H3.44935C4.66852 7.56676 5.66602 8.56426 5.66602 9.78343V20.8668C5.66602 22.0859 4.66852 23.0834 3.44935 23.0834H3.13268C1.91352 23.0834 0.916016 22.0859 0.916016 20.8668V9.78343C0.916016 8.56426 1.91352 7.56676 3.13268 7.56676ZM11.9993 0.916759C13.2185 0.916759 14.216 1.91426 14.216 3.13343V20.8668C14.216 22.0859 13.2185 23.0834 11.9993 23.0834C10.7802 23.0834 9.78268 22.0859 9.78268 20.8668V3.13343C9.78268 1.91426 10.7802 0.916759 11.9993 0.916759ZM20.866 13.5834C22.0852 13.5834 23.0827 14.5809 23.0827 15.8001V20.8668C23.0827 22.0859 22.0852 23.0834 20.866 23.0834C19.6469 23.0834 18.6494 22.0859 18.6494 20.8668V15.8001C18.6494 14.5809 19.6469 13.5834 20.866 13.5834Z",
    fill: "#FCBC5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamics);
export default __webpack_public_path__ + "static/media/dynamics.ecba6eaca846221a5f22365c5d7616f2.svg";
export { ForwardRef as ReactComponent };